import { render } from "./left_l_bar.vue?vue&type=template&id=5e21ba13"
import script from "./left_l_bar.vue?vue&type=script&lang=js"
export * from "./left_l_bar.vue?vue&type=script&lang=js"
script.render = render

export default script